module.exports = __webpack_public_path__ + "static/media/aws.37bd4355.png";